import { render, staticRenderFns } from "./WebsiteServices.vue?vue&type=template&id=04b5706f&scoped=true"
import script from "./WebsiteServices.vue?vue&type=script&lang=js"
export * from "./WebsiteServices.vue?vue&type=script&lang=js"
import style0 from "./WebsiteServices.vue?vue&type=style&index=0&id=04b5706f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b5706f",
  null
  
)

export default component.exports